import { useQuery } from '@tanstack/react-query'
import { useOrderItemsService } from '@/flight-deck-api/services/order-items.service'
import { useSession } from '@/providers/session'

export interface UseOrderItemOptions {
  campaignGroupId: number
  cacheInvalidationKey?: number | string
  enabled?: boolean
  staleTime?: number
  gcTime?: number
}

/**
 * Hook for fetching order item by campaign group ID
 * @param options - Configuration options for the query
 * @returns Order item data, loading state, and errors
 */
export const useOrderItem = ({
  campaignGroupId,
  cacheInvalidationKey,
  enabled = true,
  staleTime = 5 * 60 * 1000, // 5 minutes default
  gcTime = 10 * 60 * 1000, // 10 minutes default
}: UseOrderItemOptions) => {
  const { getOrderItemByCampaignGroupId } = useOrderItemsService()
  const { isLoaded: isSessionLoaded } = useSession()

  return useQuery({
    queryKey: ['getOrderItemByCampaignGroupId', campaignGroupId, cacheInvalidationKey],
    queryFn: () =>
      // biome-ignore lint/plugin: RETIRED, do not copy. Call it through useSelectQuery/useSelectMutation when touching this.
      getOrderItemByCampaignGroupId.handler({
        campaignGroupId,
      }),
    enabled: isSessionLoaded && !!campaignGroupId && enabled,
    staleTime,
    gcTime,
  })
}
